// src/domains/filters/filters.store.ts

import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { IUnifiedDynamicFilters } from './filters.types';
import { customStorage } from '@/shared/lib/storage';
import { registerClear } from '@/shared/lib/storesRegistry';

interface IFiltersStore {
  filtersByCustomer: Record<string, IUnifiedDynamicFilters>;
  setFilters: (customerId: string, filters: IUnifiedDynamicFilters) => void;
  getFilters: (customerId: string) => IUnifiedDynamicFilters | undefined;
  clearFilters: () => void;
}

export const useFiltersStore = create<IFiltersStore>()(
  devtools(
    persist(
      (set, get) => ({
        filtersByCustomer: {},
        setFilters: (customerId, filters) =>
          set((state) => ({
            filtersByCustomer: {
              ...state.filtersByCustomer,
              [customerId]: filters,
            },
          })),
        getFilters: (customerId) => get().filtersByCustomer[customerId],
        clearFilters: () => set({ filtersByCustomer: {} }),
      }),
      {
        // Bumped after CUPO-1549: agencies vs invoice_agencies from source-filter-options
        name: 'customer-filters-storage-v1',
        storage: customStorage,
      },
    ),
    { name: 'CustomerFiltersStore' },
  ),
);

registerClear(useFiltersStore.getState().clearFilters);
